export const GET_FOREX = './forexMetrics/redux/GET_FOREX';
export const GET_CRYPTOS = './forexMetrics/redux/GET_CRYPTOS';
export const GET_STOCKS = './forexMetrics/redux/GET_STOCKS';
export const GET_EFTS = './forexMetrics/redux/GET_EFTS';
export const GET_MAJORS = './forexMetrics/redux/GET_MAJORS';
